import Sugar from 'sugar';

Sugar.extend();
